<template>
  <b-sidebar :width="$store.state.app.messenger.wide?'95vw':'55vw'" no-header right backdrop shadow v-model="showModal" @change="visibleChanged">
    <div class="d-flex justify-content-between app-chat">
      <div class="chat-wrapper" :class="{'expanded': $store.state.app.messenger.wide}">
        <div class="chat-navleft">
          <nav class="nav flex-column">
            <a @click="handleClose()" class="nav-link" role="button">
              <feather type="x" style="width: 24px; height: 24px"></feather>
            </a>
            <a @click="toggleChatExpand()" class="nav-link" role="button">
              <feather :type="$store.state.app.messenger.wide ? 'minimize':'maximize'" style="width: 24px; height: 24px"></feather>
            </a>
            <a @click="setFlag({id: 0})" class="nav-link" role="button">
              <feather type="users" style="width: 24px; height: 24px"></feather>
            </a>
          </nav>
        </div>
        <div class="chat-sidebar">
          <div class="chat-sidebar-header">
            <a href="#" data-toggle="dropdown" class="dropdown-link" aria-expanded="false">
                <div class="d-flex align-items-center">
                  <!-- <div class="avatar avatar-sm mg-r-8"><span class="avatar-initial rounded-circle">X</span></div> -->
                  <!-- <span class="tx-color-01 tx-semibold">{{mode==1 ? 'Хэрэглэгчид':'Харилцан яриа'}}</span> -->
                  <span class="tx-color-01 tx-semibold">Мессенжер</span>
                </div>
                <a @click.stop="composeNew()">
                  <feather type="send"></feather>
                </a>
            </a>
            <!-- <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(249px, 60px, 0px);">
              <a @click="loadTeams()" class="dropdown-item" role="button">
               <feather type="users" style="width: 24px; height: 24px" class="mg-r-5"></feather> Харилцан яриа
              </a>
              <a @click="loadUsers()" class="dropdown-item" role="button">
                <feather type="user" style="width: 24px; height: 24px" class="mg-r-5"></feather> Хэрэглэгчид
              </a>
            </div> -->
          </div>
          <div class="chat-sidebar-body">
            <!-- <div v-if="mode==1" class="chat-msg-list">
              <a @click="loadChat(u.un, true)" role="button" class="media" v-for="(u,i) in users_filtered" :key="i">
                <div :class="`avatar avatar-sm avatar-${u.isOnline=='b'?'online':'offline'}`">
                  <img :src="u.f06" class="rounded-circle" alt="">
                </div>
                <div class="media-body mg-l-10">
                  <h6 class="mg-b-0">{{ u.f02 }}</h6>
                  <small class="d-block tx-color-04" v-if="u.f09.length">
                    {{ u.f09[0].p01 }}, {{ u.f09[0].p07 }}
                  </small>
                </div>
              </a>
            </div> -->
            <!-- v-else-if="mode==2" -->
            <div  class="flex-fill pd-y-20 pd-x-10">
              <nav id="allChannels" class="nav flex-column nav-chat mg-b-20">
                <a v-for="(c,i) in team_filtered" :key="`${i}_cc`" @click="loadConversation(c.id, c.team, true, c)" 
                  :class="`nav-link ${c.id==convCur.id?'active':''}`" role="button">
                  {{c.flag==-1?'@':'#'}} {{c.team}}
                  <span v-show="c.count>0" class="badge badge-light">{{c.count}}</span>
                </a>
              </nav>
            </div>
          </div>
          <div class="chat-sidebar-footer pd-l-10-f">
            <div class="d-flex align-items-center dropdown dropup">
              <a id="dropupMenuButton" class="pd-r-5 dropdown-toggle" data-toggle="dropdown">
                <feather type="filter"></feather>
              </a>
              <div class="dropdown-menu tx-13" aria-labelledby="dropupMenuButton">
                 <ul class="nav nav-pills flex-column">
                  <li v-for="(f,i) in flags" :key="`fl_${i}`" class="nav-item">
                    <a @click="setFlag(f)" class="nav-link" role="button">{{f.name}}</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="search-form d-none d-sm-flex">
                <input v-model="filterParam.fullname" type="search" class="form-control" placeholder="Хайх">
                <button class="btn" type="button">
                  <feather type="search" style="width: 16px; height: 16px"></feather>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="chat-content">
          <div class="chat-content-header">
            <!-- <h6 v-if="convCur.id>0" class="mg-b-0">{{convCur.team}}</h6> -->
            <div v-if="convCur.obj.flag!=undefined && convCur.obj.flag!=-1" class="d-flex align-items-center">
              <ul class="nav nav-pills mg-r-5">
                <li class="nav-item">
                  <a class="nav-link" data-toggle="dropdown" aria-expanded="false">
                    <feather type="menu" style="width: 16px; height: 16px"></feather>
                  </a>
                  <div class="dropdown-menu tx-13">
                    <a @click="renameTeam()" role="button" class="dropdown-item">Нэр солих</a>
                    <a @click="archiveTeam()" role="button" class="dropdown-item">Архивлах</a>
                  </div><!-- dropdown-menu -->
                </li>
              </ul>

              <a @click="showMention()" role="button">
                <feather type="users" style="width: 16px; height: 16px"></feather>
                <sup>{{convCur.memberCount}}</sup>
              </a>
            </div>

            <!-- {{convCur.team}} -->            

            <ul class="nav nav-pills" v-if="convCur.ots.length>0">
              <li class="nav-item" v-for="(o,i) in convCur.ots.length>3 ? convCur.ots.slice(0,3) : convCur.ots" :key="i">
                <a @click="setTab(o.id)" class="nav-link" :class="{'bg-light': o.id==convCur.tabId}" role="button" v-html="o.name"></a>
              </li>
              <li class="nav-item" v-if="convCur.ots.length>3">
                <a class="nav-link" href="#" data-toggle="dropdown">Бусад <feather type="chevron-down"></feather></a>
                <div class="dropdown-menu tx-13">
                  <a v-for="(o,i) in convCur.ots.slice(3,convCur.ots.length)" :key="`${i}_dd`" role="button" class="dropdown-item"
                   @click="setTab(o.id)" v-html="o.name">{{o.nameclr}}</a>
                </div>
              </li>
            </ul>
            
            <!-- <div class="d-flex">
              <div class="search-form mg-l-15 d-none d-sm-flex">
                <input type="search" class="form-control" placeholder="Search">
                <button class="btn" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg></button>
              </div>
            </div> -->
          </div>
          <vuescroll ref="mainScrll" :ops="scrollOps" @handle-scroll="handleScroll" class="chat-content-body">
             <div class="chat-group" v-if="convCur.tabId==0">
              <section v-for="(c,i) in convCur.chats" :key="i" >
              <div v-show="isDrawGroupDateRange(i)" class="chat-group-divider">{{c.date}}</div>
                <div class="media mg-b-5">
                  <div v-if="c.user.id!=$store.state.user.userInfo.profileId" @click="handleUserInfoModal(c.user.id)" role="button" :class="`avatar avatar-sm avatar-${c.isOnline=='b' ? 'online':'offline'}`">
                    <img :src="c.user.avator" class="rounded-circle" alt="" />
                  </div>
                  <div :class="`media-body`">
                    <h6 class="mg-b-0" v-if="c.user.id!=$store.state.user.userInfo.profileId">
                      <span @click="handleUserInfoModal(c.user.id)" role="button">{{c.user.fullName}}</span>
                      <!-- <small>{{c.user.id}}</small> -->
                    </h6>
                    <!-- <p>{{c.msg}}</p> -->
                    <div v-if="c.msgType==0" class="d-flex">
                      <div v-if="c.user.id==$store.state.user.userInfo.profileId" class="mg-l-auto bg-info rounded pd-x-5 pd-y-1 text-white">
                        {{c.msg}}
                      </div>
                      <div v-else>
                        {{c.msg}}
                      </div>
                    </div>
                    <div v-else-if="c.msgType > 10000 && c.msgType < 10999">
                      <div class="text-inherit">
                        <router-link v-if="c.customResponse.rawUrl != '' && c.customResponse.rawUrl != null"
                          :to="c.customResponse.rawUrl" class="tx-11 link-03">
                          <feather
                            :type="getMsgIcon(c.msgType)"
                            :size="13"
                            :stroke-width="1"
                            :title="c.customResponse.customTitle"
                            class="pd-r-5"
                          ></feather>
                        </router-link>
                        {{ c.msg }}
                      </div>
                    </div>
                    <div v-else-if="c.msgType == -2" @click="connect()">
                      <span class="ivu-alert-message">Сүлжээний холболт</span>
                      <span class="ivu-alert-desc">
                        Сүлжээний холболт салсан байна.
                        <a>ЭНД дарж дахин холбогдоно уу.</a>
                      </span>
                    </div>
                    <div v-else-if="c.msgType == 1">
                      <div
                        class="bg-light mg-l-5 d-flex align-items-center tx-12 pd-5"
                        @click="openLink(c.attach)"
                        role="button"
                        style="border-radius: 10px"
                      >
                        <img
                          class="rounded mg-r-5"
                          v-if="
                            c.attach.ext == 'jpg' ||
                              c.attach.ext == 'jpeg' ||
                              c.attach.ext == 'png'
                          "
                          :src="`${c.attach.link}?w=42&h=42&mode=crop`"
                        />
                        <!-- <img    v-else :src="getthumb(c.attach.ext)" /> -->
                        <div>
                          {{ c.attach.name }}
                          <div class="text-right text-muted">
                            {{ getSize(c.attach.size) }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="c.msgType == 2" class="tx-12">
                        <tasks-item :tsks="[c]" @show-task="showTask($event)" :fromMe="c.user.id==$store.state.user.userInfo.profileId" />
                    </div>
                    <div v-else-if="c.msgType == 3"><a :href="c.msg" target="_blank" class="tx-brand-01">{{c.msg}}</a></div>
                    <div v-else-if="c.msgType == 5 || c.msgType == 6" class="text-muted tx-12" role="button" @click="handleUserInfoModal(c.task.id)">
                      <span class="font-weight-bold">{{ c.task.lat }}&nbsp;{{ c.task.task }}</span> хэрэглэгчийг <i>{{ c.msgType == 6 ? "хаслаа" : "нэмлээ" }}.</i>
                    </div>
                    <div v-else-if="c.msgType == -1" class="text-muted tx-12">бүлгийг <b>үүсгэв.</b></div>
                    <div v-else-if="c.msgType == 7" class="text-muted tx-12">бүлгийг <b>сэргээв.</b></div>
                    <div v-else-if="c.msgType == 8" class="text-muted tx-12">бүлгийг <b>архивласан.</b></div>
                    <div v-else-if="c.msgType == 9" class="text-muted tx-12">бүлгийн <b>нэр сольсон.</b></div>
                  </div>
                </div>
              </section>
                <br /><br /><br /><br /><br /><br />
              </div>
              <div v-else-if="convCur.tabId==-6" class="filemgr-content-body" style="top: 0; bottom: 60px">
                <div class="pd-x-20 pd-y-10">
                <div class="row row-xs" v-if="convCur.files.length > 0">
                  <file-item
                    :hideDrpDwn="true"
                    @on-attach="showFile($event)"
                    role="button"
                    :colmd="3"
                    :obj="f"
                    v-for="(f, i) in convCur.files"
                    :key="i"
                  ></file-item>
                  </div>
                </div>
              </div>
              <div v-else>
                <!-- {{convCur.tasks}} -->

                <tasks-item :tsks="convCur.tasks" @show-task="showTask($event)" listings />
              </div>
              
            </vuescroll>
          
          <div class="chat-content-footer">
            <a  class="chat-plus" data-original-title="Add File">
              <feather type="file" style="width: 24px; height: 24px"></feather>
            </a>
            <form @submit.prevent="sendMessage()" class="wd-100p">
              <input v-model="composeObj.txt" type="text" class="form-control align-self-center bd-0 ht-100p" placeholder="Мессеж" />
            </form>

            <nav>
              <a @click="sendMessage()" data-toggle="tooltip" title="" data-original-title="Add GIF">
                <feather type="send" style="width: 24px; height: 24px"></feather>
              </a>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <task-detail-side
      v-if="taskDialogSide.id > 0"
      :id.sync="taskDialogSide.id"
      @on-task-close="taskDialogSide.id = 0"
    ></task-detail-side>

    <file-dialog :show="fileDialog.show" :id="fileDialog.id" @on-hide="fileDialog.show = false" />

    <mention-users :show="projectMention.show" :obj.sync="convCur" :module="projectMention.module"
      @on-force="loadConversation(convCur.id, '', true)" @on-composed="filterParam.flag= 0; loadTeams($event);" @on-mention-close="projectMention.show = false" ></mention-users>

    <b-modal v-model="mdlRenameTeam" title="Нэр солих" >
      <Form label-position="top" label-width="100%">
        <FormItem label="Бүлгийн нэр">
          <Input v-model="convCur.team" ></Input>
        </FormItem>
      </Form>
      <template #modal-footer>
        <div class="mg-l-auto btn-group">
          <button @click="mdlRenameTeam = false" type="button" class="btn btn-danger btn-xs btn-uppercase">
            Хаах
          </button>
          <button @click="saveData()" type="button" class="btn btn-primary btn-xs btn-uppercase">
            Хадгалах
          </button>
        </div>
      </template>
    </b-modal>

  </b-sidebar>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";

import vuescroll from "vuescroll";
import "element-ui/lib/theme-chalk/index.css";
import { Drawer, Dialog, Form, FormItem, Input } from "element-ui";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { getSize } from "@/libs/tools";
const moment = require("moment");
var _ = require("lodash");

export default {
  components:{
    vuescroll, Drawer, Dialog, Form, FormItem, Input, 
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    mentionUsers: () => ({
      component: import("@/components/project/mention.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileItem: () => ({
      component: import("@/components/modules/media/item"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    tasksItem: () => ({
      component: import("@/components/main/messengerTasks.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    isShow: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      scrollOps: {
        //maxHeight: 300,
        vuescroll: {
          //maxHeight: 300,
        },
        scrollPanel: {
          //maxHeight: 300
        },
        rail: {},
        bar: {}
      },
      isInited: false,
      filterParam:{
        fullname: '',
        flag: 0,
      },
      modal: false,
      rdy: false,
      task: {},
      mode: 0,
      flags:[],
      conversations: [],
      chatLogs: [],
      chats: [],
      chatsUser: null,
      fileDialog: {
        id: null,
        show: false,
      },
      taskDialog: {
        show: false,
        id: 0,
        key: 0
      },
      taskDialogSide: {
        show: false,
        id: 0,
        key: 0
      },
      convCur:{
        id: 0,
        obj: {},
        tabId: 0,
        team: '',
        chats:[],
        members:[],
        memberCount: null,
        files: [],
        ots: [
          {id: 0, name: 'Чат' }
        ],
        isScrollHandled: false,
        curPage: 0,
        pageSize: 20,
        tasks: [],
      },
      composeObj: {
        txt: "",
        type: 0,
        chooserShow: false,
        attachIds: [],
        attachList: []
      },
      chatAttachOption: {
        type: 0,
        title: "",
        rawUrl: ""
      },
      teamId: null,
      projectMention: {
        module: "team",
        show: false,
      },
      mdlRenameTeam: false,
    };
  },
  mounted(){
    let self= this;
    //console.error('************************************************************************************************************************************************************************************************************************************************');
    require("@/assets/scss/pages/messenger.scss");
    require("@/assets/scss/pages/filemgr.scss");
    // this.taskDialog.show= false;

    // if (this.teamId > 0) {
    //   this.setChatAttachOption();
    //   let self = this;
    //   this.loadConversation(this.teamId, "", true);
      this.$store.state.signalr.osrCon.on(
        "v2recieveTeamMessage",
        (
          date,
          teamId,
          msg,
          type,
          objectId,
          profileId,
          fullName,
          avator,
          attach,
          cstmResp
        ) => {
          //console.log('v2recieveTeamMessage frdeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee', this.convCur.id == teamId
          //, this.$store.state.signalr.team);
          if (this.convCur.id == teamId) {
            //console.log('stp1');
            this.convCur.chats.push({
              msg: msg,
              date: date,
              msgType: type,
              groupDate: null,//self.getDateGroupName(date),
              user: {
                id: profileId,
                avator: avator,
                fullName: fullName
              },
              attach: {
                id: attach.id,
                groupId: attach.groupId,
                name: attach.name,
                link: attach.link,
                ext: attach.ext,
                size: attach.size
              },
              customResponse: cstmResp
            });
            this.sortConversations(this.convCur.id, profileId == this.$store.state.user.userInfo.profileId);

            this.setLastSeenDate(teamId);
          }
          else if(profileId == this.$store.state.user.userInfo.profileId) {
            //this.filterParam.flag= 0;
            this.loadTeams(teamId);
          } else {
            //console.log('step 5 end yag irsnuv');
            this.sortConversations(teamId);
            //this.loadConversation(teamId,);
            //console.log(profileId, this.$store.state.user.userInfo.profileId)
            //console.log('stp2', this.$store.state.signalr.team, this.$store.state.signalr.team.notSeenConversationCount);
            this.handleTeamNotSeenCount(this.$store.state.signalr.team.notSeenConversationCount + 1);
          }
          // else {
          //   let _cc = this.conversations.filter(x => x.id == teamId);
          //   if (_cc.length) {
          //     _cc[0].count++;
          //   } else {
          //     getTeamConversations({ id: teamId, skip: 0, size: 1 }).then(res => {
          //       if (res != false && res.data.conversations.length) {
          //         let _cc = res.data.conversations[0];
          //         _cc.count++;
          //         this.conversations.unshift(_cc);
          //       }
          //     });
          //   }
          // }
        }
      );
    // }
    this.$nextTick(function() {
      window.addEventListener("resize", this.getWindowHeight);
      this.getWindowHeight();
    });

  },
  methods: {
    ...mapActions(["handleTeamNotSeenCount", "handleLoading", "handleMainReportDialog", "handleMessenger", "handleGroupUsers", "handleUserInfoModal"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getWindowHeight() {

    },
    setLastSeenDate(teamId){
      request({
        api: { url: "team/SetLastSeenDate", method: "post" },
        data: { id: teamId }
      }).then(() => {
        if (this.$refs["mainScrll"] != undefined) {
          this.$refs["mainScrll"].scrollTo(
            {
              y: "150%"
            },
            300
          );
        }
      });
    },
    setChatAttachOption() {
      if (this.obj != null) {
        this.chatAttachOption.title = this.obj.title;
        this.chatAttachOption.rawUrl = this.$route.path;
        if (this.$route.name == "lmsCourseView") {
          this.chatAttachOption.type = 10115;
        } else if (this.$route.name == "lmsLessonView") {
          if (this.$route.params.bot == 6 || this.$route.params.bot == 286)
            this.chatAttachOption.type = 10006;
          else if (this.$route.params.bot == 0)
            this.chatAttachOption.type = 10114;
          else this.chatAttachOption.type = this.$route.params.bot + 10000;
        }
      }
    },
    init() {
      //console.log('msngr inited', this.$store.state.app.messenger.openId, !this.isInited);
      if((!this.isInited) || this.$store.state.app.messenger.openId!=this.convCur.id){
        this.isInited= true;
        if(this.$store.state.app.messenger.activeFlag!=undefined && this.$store.state.app.messenger.activeFlag!=null){
          this.filterParam.flag= this.$store.state.app.messenger.activeFlag;
        }
        this.loadTeams(this.$store.state.app.messenger.openId);
      }
    },
    loadUsers(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      this.handleGroupUsers({ store: this.$store }).then(()=>{
        this.toggleBodyClass("removeClass", "dynamic-locker");
        this.mode=1;
      });
    },
    sortConversations(id, fromMe){
      
      if(id!=undefined && id!=null && id>0){
        //console.log('step 6');
        if(this.conversations.filter(x=>x.id==id).length>0){          
          this.conversations.filter(x=>x.id==id)[0].dd= moment(new Date()).format("YYYY-MM-DDTHH:mm:ss.SSS");

          if(fromMe!=undefined && fromMe!=null && fromMe==false){
            this.conversations.filter(x=>x.id==id)[0].count++;
          }else{
            this.conversations.filter(x=>x.id==id)[0].count= 0;
          }

          // console.log('this.conversations.filter(x=>x.id==id)[0].dd', this.conversations.filter(x=>x.id==id)[0].dd);
          // console.log('this.conversations', this.conversations);
        }
      }
      this.conversations= _.orderBy(this.conversations, ["dd"], ["desc"]);
      //_.orderBy(q.as, ["sec"], ["asc"]);
    },
    loadTeams(teamId){
      console.log('loadTeams frd', teamId, this.filterParam.flag);
      request({
        api: { method: "get", url: "team/GetTeamConversations" },
        params: { 
          id: 0,
          page: 0,
          size: 10,
          flag: this.filterParam.flag,
          //flag: 115,
        },
        store: this.$store,
      }).then((res) => {
        //console.log('ld tms', res);
        if (res != false) {



          this.conversations = res.data.conversations;
          this.flags= res.data.flags;
          this.sortConversations(null, false);
          //console.log('loadTeams ', res);
          this.mode= 2;
          this.rdy = true;

          //this.loadChatlogs();

          if(teamId!=undefined && teamId!=null && teamId>0){

            let obj= this.$store.state.app.messenger;
              obj.openId= null;
              obj.activeFlag= null;
              this.handleMessenger(obj);

            let _tm ={};
            if(this.conversations.filter(x=>x.id==teamId).length>0){
              _tm= this.conversations.filter(x=>x.id==teamId)[0];
            }
            this.loadConversation(teamId, '', true, _tm);
          }
        }
      });
    },
    setTab(tabId){
      
      if(tabId==0){
        this.convCur.tabId= tabId;
      } else if(tabId==-6){
        //this.convCur.files=[]
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "get", url: "Team/GetTeamFiles" },
          params: { 
            id: this.convCur.id,
            page: 0,
            size: 1000,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.convCur.files= res.data.files.map(function (e) {
              let ext = e.e;
              var lastInd = e.link.lastIndexOf("?");
              //console.log(e.link, lastInd);
              e.l = e.link.substring(0, lastInd);
              e.dt = e.date;
              e.ex = e.e;
              e.s =
                e.size > 1024
                  ? (e.size / 1024 / 1024).toFixed(2) + "MB"
                  : (e.size / 1024).toFixed(2) + "KB";
              var lastIndex = e.title.lastIndexOf(".");
              e.t = e.title.substring(0, lastIndex);
              switch (e.title.substring(lastIndex + 1)) {
                case "jpg":
                case "jpeg":
                case "png":
                  ext = "image";
                  break;
                case "doc":
                case "docx":
                  ext = "word";
                  break;
                case "xls":
                case "xlsx":
                  ext = "excel";
                  break;
                case "ppt":
                case "pptx":
                  ext = "powerpoint";
                  break;
                case "txt":
                  ext = "alt";
                  break;
                case "html":
                case "css":
                case "js":
                  ext = "code";
                  break;
                case "mp4":
                  ext = "video";
                  break;
                case "mp3":
                  ext = "audio";
                  break;
                case "pdf":
                  ext = "pdf";
                  break;
                default:
                  break;
              }
              e.ext = ext;
              return e;
            });
            this.convCur.tabId= tabId;
          }
        });
      }else{
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "get", url: "Team/GetTeamTasks" },
          params: { 
            id: this.convCur.id,
            ot: tabId,
            page: 0,
            size: 1000,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            //console.log('stp4', res.data);
            this.convCur.tasks= res.data.apps;
            this.convCur.tabId= tabId;
          }
        });
      }
    },
    fillTeamInfo(teamId){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: "Team/GetTeamApps" },
        params: { 
          id: teamId
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('GetTeamApps', res);
          this.setLastSeenDate(teamId);

          if(res.data.attachCount>0){
            this.convCur.ots.push({id: -6, name: `Файл <sup class="badge badge-light">${res.data.attachCount}</sup>`, nameclr: ''});
          }

          // if(res.data.task!=null){
          //   this.convCur.ots.push({id: res.data.task.objectType.id, name: res.data.task.objectType.title, nameclr: ''});
          // }
          if(res.data.apps.length>0){
            res.data.apps.map((app)=>{
              this.convCur.ots.push({id: app.objecTypeId, name: `${app.objectName} <sup class="badge badge-light">${app.count}</sup>`, nameclr: app.objectName});
            });
          }

          this.convCur.memberCount= res.data.userCount;
        }
      });
    },
    loadConversation(teamId, team, force, obj){
      //console.log('loadConversation', teamId, team, force, obj);
      let self= this;

      
      
      //console.log('force!=undefined && force', teamId,  force!=undefined && force, force);      
      //console.log('(force!=undefined && force) || (this.convCur.id != teamId)', (force!=undefined && force) || (this.convCur.id != teamId));

      if ((force!=undefined && force) || (this.convCur.id != teamId)) {
        this.convCur.id = teamId;
        this.convCur.obj = obj;
        this.convCur.isScrollHandled = true;
        this.convCur.chats = [];
        //this.composeObj.chooserShow = false;
        //this.handleTeamId(0);

        this.convCur.ots= [{id: 0, name: 'Чат', nameclr: ''}];
        this.convCur.tabId= 0;

        this.fillTeamInfo(teamId);
      }

      

      

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: "team/GetChatLog" },
        params: { 
          skip: this.convCur.chats.length,
          size: this.convCur.pageSize,
          teamId: teamId
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //this.sortConversations(teamId, true)
          //console.log('ss1', res);

          this.convCur.chatsCount = res.data.count;
          _.orderBy(res.data.chats, ["id"], ["desc"]).forEach(value => {
            Object.assign(value, {
              groupDate: self.getDateGroupName(value.date)
            });
            self.convCur.chats.unshift(value);
          });

          //console.log('step 33', teamId , this.convCur.chats.length, this.convCur.pageSize, res.data.chats.length);

          this.convCur.team = team;
          //this.convCur.team = "";
          

          let goPos = 0;
          if (this.$refs["mainScrll"] != undefined)
            goPos = this.$refs["mainScrll"].scrollContentElm.offsetHeight;

          this.$nextTick(()=> {
            if (this.$refs["mainScrll"] != undefined) {
              if (!force) {
                let afterPos = this.$refs["mainScrll"].scrollContentElm.offsetHeight;
                this.$refs["mainScrll"].scrollTo( { y: afterPos - goPos }, 0 );
              } else {
                this.$refs["mainScrll"].scrollTo( { y: "150%" }, 0 );
              }
            }
            this.convCur.isScrollHandled = false;
          });

        }
      });
    },
    // loadChatlogs(){
    //   //messenger/GetChatConversation
    //   this.toggleBodyClass("addClass", "dynamic-locker");
    //   request({
    //     api: { method: "get", url: "messenger/GetChatConversation" },
    //     params: { 
    //       page: 0,
    //       size: 10,
    //     },
    //     store: this.$store,
    //   }).then((res) => {
    //     this.toggleBodyClass("removeClass", "dynamic-locker");
    //     if (res != false) {
    //       this.chatLogs = res.data.conversations;
    //     }
    //   });
    // },
    urlify(text) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function(url) {
          return '<a target="_blank" href="' + url + '">' + url + '</a>';
      })
    },
    showAttach(msg){
      this.toggleChatExpand(true);
      this.fileDialog.id= msg.aId;
      this.fileDialog.show= true;
    },
    showFile(attId){
      this.showAttach({aId: attId});
    },
    openLink(att){
      this.showAttach({aId: att.id});
    },
    getSize(size) {
      return getSize(size);
    },
    showTask(msg){
      //console.log('showTask', msg);
      this.toggleChatExpand(true);
      //this.taskDialog.id= msg.tId;
      // this.taskDialog.id= msg;
      // this.taskDialog.show= true;
      this.taskDialogSide.id = msg;
    },
    taskHide(){
      //console.log('hideTask өшжуб');
      this.taskDialog.show = false; 
      this.taskDialog.id = 0;
    },
    loadChat(uname, force){
      let self= this;

      if(force!=undefined && force){
        this.chats= [];
      }

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: "messenger/GetChatLog" },
        params: { 
          to: uname,
          page: 0,
          size: 10,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //this.chats = res.data.chats;
          //console.log('this.$store.state.signalr.users', this.$store.state.signalr.users.filter(x=>x.un==uname));
          if(this.$store.state.signalr.users.filter(x=>x.un==uname).length>0){
            this.chatsUser= this.$store.state.signalr.users.filter(x=>x.un==uname)[0];
          }else{
            this.chatsUser= null;
          }
          //console.log('self.$store.state.user.userInfo.user_name', self.$store.state.user.userInfo);
          res.data.chats.forEach((value, index) => {
            //console.log('_from', value)
            var ms = {};
            if (value._from === self.$store.state.user.userInfo.user_name) ms.direction = "fromYou";
            else ms.direction = "fromMe";
            ms.msg = value.type==0 ? self.urlify(value.msg) : value.msg;
            ms.datetime = value.date;
            //ms.groupDate = self.getDateGroupName(value.date),
            ms.type = value.type;
            ms.anm = value.anm;
            ms.tnm = value.tnm;
            ms.pnm = value.pnm;
            ms.aId = value.aId;
            ms.tId = value.tId;
            ms.t = value.t;
            ms.pId= value.pId;
            ms.flag = value.flag;
            ms.flagdate = value.flagDate;
            self.chats.unshift(ms);
          });

          //this.rdy = true;
        }
      });
    },
    handleClose(){
      this.$emit('on-hide');
    },
    visibleChanged(e) {
      if (!e) {
        //this.isInited= false;
        //this.conversations= [];
        //this.convCur.id= null;
        //this.convCur.chats= [];
        //Object.assign(this.$data, this.$options.data());
        this.$emit("on-hide");
      }
    },
    toggleChatExpand(force){
      let obj= this.$store.state.app.messenger;
      obj.wide= (force!=undefined && force) ? true : !obj.wide;
      this.handleMessenger(obj).then(()=>{
        this.showMessenger = false;
      });
    },
    connect: function() {
      let self = this;
      this.$store.state.signalr.osrCon
        .start()
        .then(function() {
          Notification.success({
            message: "Амжилттай холбогдлоо.",
            duration: 5000
          });
          let ind = self.convCur.chats.map(x => x.type).indexOf(-2);
          self.convCur.chats.splice(ind, 1);
        })
        .catch(() => {
          Notification.info({
            message: "Интернет холболтоо шалгана уу.",
            //title: "Мэдэгдэл",
            duration: 30000,
            type: "info",
            position: "top-right",
            offset: 50
          });
        });
    },
    getMsgIcon(type) {
      switch (type - 10000) {
        case 115:
          return "briefcase";
        case 6:
          return "paperclip";
        case 114:
          return "file";
        default:
          return "clipboard";
      }
    },
    getDateGroupName(d) {
      let rv = "";

      if (moment(d).isSame(new Date(), "day")) {
        rv = "Өнөөдөр";
      } else if (moment(d).isSame(moment().subtract(1, "day"), "day")) {
        rv = "Өчигдөр " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(moment().subtract(2, "day"), "day")) {
        rv = "Уржигдар " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(new Date(), "week")) {
        rv = "Энэ долоо хоногт";
      } else if (moment(d).isSame(moment().subtract(1, "week"), "week")) {
        rv = "Өнгөрсөн долоо хоногт";
      } else if (moment(d).isSame(new Date(), "month")) {
        rv = "Энэ сард";
      } else if (moment(d).isSame(moment().subtract(1, "month"), "month")) {
        rv = "Өнгөрсөн сард";
      } else if (moment(d).isSame(new Date(), "year")) {
        rv = moment(d).format("MMMM") + "д";
        //rv= 'Энэ жилд';
      } else if (moment(d).isSame(moment().subtract(1, "year"), "year")) {
        rv = "Өнгөрсөн жилд";
      } else {
        rv = moment(d).format("YYYY") + " онд";
        //rv='Бусад';
      }
      return rv;
    },
    isDrawGroupDateRange(i) {
      if (i == 0) {
        return true;
      } else if (
        this.convCur.chats[i]["groupDate"] !=
        this.convCur.chats[i - 1]["groupDate"]
      ) {
        return true;
      } else {
        return false;
      }
    },
    handleScroll(vertical) {
      //console.log('handlescrl fired handlescrl fired');
      if (vertical.scrollTop < 20 && !this.convCur.isScrollHandled) {
        this.convCur.curPage = this.convCur.curPage + 1;
        if (
          this.convCur.chats.length < this.convCur.chatsCount &&
          !this.convCur.isScrollHandled
        ) {
          this.convCur.isScrollHandled = true;
          //console.log('ene ved hed bsan be', this.convCur.id);
          this.loadConversation(this.convCur.id, this.convCur.team, false);
        }
      }
    },
    sendMessage() {
      let self = this;
      if (
        self.$store.state.signalr.osrCon != undefined &&
        self.$store.state.signalr.osrCon.connection != undefined &&
        self.$store.state.signalr.osrCon.connection.connectionState == 1
      ) {
        let embedMsgType = this.composeObj.type;
        if (
          this.composeObj.type == 0 &&
          this.chatAttachOption.type > 10000 &&
          this.chatAttachOption.type < 10999
        ) {
          embedMsgType = this.chatAttachOption.type;
        }
        this.$store.state.signalr.osrCon
          .invoke(
            "v2sendTeamMessage",
            this.$store.state.user.userInfo.profileId,
            this.convCur.id,
            this.composeObj.txt,
            embedMsgType,
            this.composeObj.type == 1 ? this.composeObj.attachId : null,
            this.chatAttachOption.rawUrl,
            this.chatAttachOption.title
          )
          .catch(() => {
            this.convCur.chats.push({
              msg: "Сүлжээний холболт салсан байна",
              msgType: -2,
              date: Date(),
              groupDate: null,//self.getDateGroupName(Date()),
              user: {
                id: this.$store.state.user.userInfo.profileId,
                avator: this.$store.state.user.userInfo.avator,
                fullName: this.$store.state.user.userInfo.fullName
              }
            });
            //this.$Notice.warning({ title: "Сүлжээний холболт салсан байна", desc: 'Дахин ачааллана уу' });
          })
          .then(() => {
            this.composeObj.chooserShow = false;
            this.composeObj.txt = "";
            this.composeObj.attachId = null;
          });
      } else {
        this.convCur.chats.push({
          msg: "Сүлжээний холболт салсан байна",
          msgType: -2,
          date: Date(),
          groupDate: null,//self.getDateGroupName(Date()),
          user: {
            id: this.$store.state.user.userInfo.profileId,
            avator: this.$store.state.user.userInfo.avator,
            fullName: this.$store.state.user.userInfo.fullName
          }
        });
      }
    },
    showMention(){
      this.projectMention.module = "team";
      this.projectMention.show = true;
    },
    composeNew(){
      this.convCur.id= 0;

      this.showMention();
    },
    renameTeam(){
      this.mdlRenameTeam= true;
    },
    saveData(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Team/UpdateTeam" },
        data: { 
          id: this.convCur.id,
          team: this.convCur.team
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.mdlRenameTeam= false;
          this.loadTeams(this.convCur.id);
        }
      });
    },
    archiveTeam(){
      if (confirm("Итгэлтэй байна уу?")) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Team/DeleteTeam" },
          data: { 
            id: this.convCur.id
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.loadTeams();
          }
        });
      }
      //this.convCur.id
    },
    setFlag(flag){
      this.filterParam.flag= flag.id;
      this.loadTeams();
    }
  },
  computed: {
    team_filtered(){
      let self = this;
      let _un = self.filterParam.fullname.toLowerCase();

      return this.conversations.filter(c => {
        return (
          c.team != null 
          && c.team.toLowerCase().indexOf(_un) > -1 
        );
      });
    },
    users_filtered: function() {
      let self = this;
      let _un = self.filterParam.fullname.toLowerCase();

      return this.$store.state.signalr.users.filter(u => {
        //console.log(u)
        return (
          //u.isOnline=='b' 
          //&& 
          
          u.f02 != null 
          && u.f02.toLowerCase().indexOf(_un) > -1 
          //&& (this.filterParam.userDepCur == null ? true : hasOneOf(this.filterParam.userIds, [u.f01]) )
        );
      });
    },
    showModal: {
      get: function () 
      {
        //console.log(this.isShow)
        if (this.isShow) {console.log("ene 2 udaa achaallal");this.init()};
        return this.isShow;
      },
      set: function () {},
    },
  },
};
</script>

<style></style>
